import { TbArrowBigUpFilled } from "react-icons/tb";
import { COLOR_MASTER, COLOR_ACCENT } from "../../../commons/LaColors";

const UpvoteClicked = () => {
  return (
    <TbArrowBigUpFilled
      size={34}
      color={COLOR_ACCENT}
      style={{
        padding: "7px",
        background: COLOR_MASTER,
        borderRadius: "50%",
        border: `1.2px solid ${COLOR_MASTER}`,
      }}
    />
  );
};

export default UpvoteClicked;
